<script setup lang="ts">
  import LoadErrorIcon from '@/shared/assets/images/load-error.svg';
  import { ColoredButton, NoDocuments } from '@/shared/ui';

  defineProps<{ title: string }>();

  const emit = defineEmits<{ retry: [] }>();
</script>

<template>
  <NoDocuments
    :title="title"
    description="Tente novamente em alguns instantes."
    :icon="LoadErrorIcon"
  >
    <ColoredButton
      text="Tentar novamente"
      data-testid="load-error-retry"
      @click="emit('retry')"
    />
  </NoDocuments>
</template>
